import * as React from "react";
import { Button } from "@fluentui/react-components";

import { UserContext } from "../store/user-contex-api";
import { logOutUser } from "../../helpers/auth/auth";
import { UserLoginInformation } from "../../helpers/auth/auth-utils";

type ButtonAppearance = "outline" | "transparent" | "subtle" | "secondary" | "primary";

export default function SignOutButton({ appearance = "subtle" }: { appearance?: ButtonAppearance }) {
  const user = React.useContext(UserContext);

  const signOutClickHandler = () => {
    const signInMethod = UserLoginInformation.getLogInMethod();
    logOutUser({ user, signInMethod });
  };

  return (
    <Button appearance={appearance} size="medium" onClick={signOutClickHandler}>
      Sign Out
    </Button>
  );
}
